/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { isToday } from 'date-fns';
import type { IntlService } from 'ember-intl';
import type { Shipment, ShipmentStateEnum } from 'graphql-models';
import { SHIPMENT_STATE_TRANSLATIONS } from 'walden-trace-app/constants/shipment-states';

export interface ShipmentListSignature {
  Args: {
    highlightedText?: string;
    onUnlock?: (id: string) => void;
    shipments: Shipment[];
  };
}

export default class ShipmentListComponent extends Component<ShipmentListSignature> {
  @service('intl') declare intlService: IntlService;

  hasError = (shipment: Shipment) => {
    return shipment.alerts.some(
      (alert) => alert.type === 'TEMPERATURE_EXCEEDED' || alert.type === 'SHOCK_DETECTED',
    );
  };

  isBoxShipment = (shipment: Shipment) => {
    return Boolean(shipment.box);
  };

  stateLabel = (state: string | undefined | null) => {
    return (
      state &&
      this.intlService.t(SHIPMENT_STATE_TRANSLATIONS[state.toUpperCase() as ShipmentStateEnum])
    );
  };

  isToday = (date: string) => {
    return isToday(new Date(date));
  };
}
